import React from "react";
import { Route, Switch } from "react-router-dom";

import { UserAdd } from "./components/User/UserAdd";
import { UserEdit } from "./components/User/UserEdit";
import { UserList } from "./components/User/UserList";
import { UserForm } from "./components/User/UserForm";
import { UserExport } from "./components/User/UserExport";
import { UserImport } from "./components/User/UserImport";
import UserGroupsList from "./components/UserGroups/UserGroupsList";
import UserGroupsView from "./components/UserGroups/UserGroupsView";
import UserImportSummary from "./components/User/UserImportSummary";
import CustomerGroupsList from "./components/CustomerGroups/CustomerGroupsList";
import CustomerGroupsAdd from "./components/CustomerGroups/CustomerGroupsAdd";
import CustomerGroupsEdit from "./components/CustomerGroups/CustomerGroupsEdit";
import CustomerGroupsForm from "./components/CustomerGroups/CustomerGroupsForm";

const defaults = {
  UserForm,
  UserList,
  UserAdd,
  UserEdit,
  UserExport,
  UserImport,
  UserGroupsList,
  UserGroupsView,
  UserImportSummary,
  CustomerGroupsForm,
  CustomerGroupsList,
  CustomerGroupsAdd,
  CustomerGroupsEdit,
};

export const roleValues = {
  ROLE_ADMIN: "Admin",
  ROLE_USER: "User",
};

export default (options = {}) => {
  const components = { ...defaults, ...options };
  const {
    UserForm,
    UserList,
    UserAdd,
    UserEdit,
    UserExport,
    UserImport,
    UserGroupsList,
    UserGroupsView,
    UserImportSummary,
    CustomerGroupsForm,
    CustomerGroupsList,
    CustomerGroupsAdd,
    CustomerGroupsEdit,
  } = components;

  return {
    routes: [
      {
        path: "/users",
        render: ({ match }) => (
          <Switch>
            <Route path={`${match.url}`} exact component={UserList} />
            <Route path={`${match.url}/export`} exact component={UserExport} />
            <Route path={`${match.url}/add`} exact>
              {(props) => <UserAdd {...props} UserForm={UserForm} />}
            </Route>
            <Route path={`${match.url}/import`} exact component={UserImport} />
            <Route
              path={`${match.url}/import/:id`}
              exact
              component={UserImportSummary}
            />
            <Route path={`${match.url}/:user`} exact>
              {(props) => <UserEdit {...props} UserForm={UserForm} />}
            </Route>
          </Switch>
        ),
      },
      {
        path: "/user-groups",
        render: ({ match }) => (
          <Switch>
            <Route path={`${match.url}`} exact component={UserGroupsList} />
            <Route
              path={`${match.url}/:usergroup`}
              exact
              component={UserGroupsView}
            />
          </Switch>
        ),
      },
      {
        path: "/customer-groups",
        render: ({ match }) => (
          <Switch>
            <Route path={`${match.url}`} exact component={CustomerGroupsList} />
            <Route path={`${match.url}/add`} exact>
              {(props) => (
                <CustomerGroupsAdd
                  {...props}
                  CustomerGroupsForm={CustomerGroupsForm}
                />
              )}
            </Route>
            <Route path={`${match.url}/:id`} exact>
              {(props) => (
                <CustomerGroupsEdit
                  {...props}
                  CustomerGroupsForm={CustomerGroupsForm}
                />
              )}
            </Route>
          </Switch>
        ),
      },
    ],
  };
};
